import { defineNuxtPlugin } from '#app'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import type { ColumnComponent } from 'tabulator-tables'
import { watch } from 'vue'

const tables: Tabulator[] = [] // global registry

export function registerTable(table: Tabulator) {
  //console.log("si registra la tabla");
  tables.push(table);
  updateColumnHeaders(table);
}

// Recursive function to update column headers
// Recursive function to update column headers

export function updateColumnHeaders(table: Tabulator) {
  //console.log("si viene por updateColumnHeaders");
  
  function updateCols(cols: ColumnComponent[]) {
    const { $i18n } = useNuxtApp() 
    cols.forEach(col => {
      const oldDef = col.getDefinition() as any; // get the current column definition
      const key = oldDef.headerLocaleId
      if (key) 
      {
        /* 
          Por alguna razon, si actualizo las columnas con frozen:true, se recalcula la posición "right", y las desubica.
          Por eso a esas columnas se las actualiza con querySelector.

          Por otro lado, sospecho que no es necesario actualizar las columnsa con col.updateDefinition(newDef), pero algo en esa función
          dispara otra cosa que beneficia el refresh de la tabla, porque actualiza el idioma en el body de la tabla, no solo los headers.

          Actualizar el cuerpo de las tablas es importante para los titles tooltips de los botones, y los status labels.
        */
        const newTitle = $i18n.t(key)
        const newDef = { ...oldDef, title: newTitle }; // copy and replace title
        //console.log(newDef);
        if(!newDef.frozen)
          col.updateDefinition(newDef); // update the column
        else
        {
          const headerElement = col.getElement();
          const titleElement = headerElement?.querySelector('.tabulator-col-title');
          if (titleElement) titleElement.textContent = newTitle as string;
        }
      }
    })
  }
  

  updateCols(table.getColumns())
}


export default defineNuxtPlugin((nuxtApp) => {
  const { $i18n } = useNuxtApp()

  // Watch locale and update all tables automatically
  watch($i18n?.locale, (newLocale) => {
    tables.forEach((table) => {
      table.setLocale(newLocale) // update pagination, noData, etc.
      updateColumnHeaders(table)
      //table.redraw();
    })
  })

  // Optional: extend Tabulator localization
  Tabulator.extendModule('localize', 'langs', {
    en: {
      pagination: { first: '<<', last: '>>', prev: '<', next: '>',page_title:"Show Page", page_size: 'Page Size', all: 'All' },
      ajax: { loading: 'Loading...', error: 'Error' },
      noData: 'No data available',
      headerFilters: { default: 'filter column...', columns: {} },
      groups: { item: 'item', items: 'items' },
      columns: {},
    },
    es: {
      pagination: { first: '<<', last: '>>', prev: '<', next: '>',page_title:"Mostrar página", all: 'Todos',
        first_title: 'Primera página',last_title: 'Última página',prev_title: 'Página anterior',
        next_title: 'Página siguiente', page_size: 'Filas por página',
        counter:{ showing: "Mostrando", of: "de", rows: "filas", pages: "páginas" }
      },
      ajax: { loading: 'Cargando...', error: 'Error al cargar los datos' },
      noData: 'No hay datos disponibles',
      headerFilters: { default: 'filtrar columna...', columns: {} },
      groups: { item: 'elemento', items: 'elementos' },
      columns: {},
    },
    "zh-cn": {
      pagination: { first: '<<', last: '>>', prev: '<', next: '>', page_title:"显示页面", all: '所有',
        first_title: '第一页', last_title: '最后一页', prev_title: '上一页',
        next_title: '下一页', page_size: '每页行数',
        counter:{ showing: "显示", of: "共", rows: "行", pages: "页" }
      },
      ajax: { loading: '加载中...', error: '加载数据出错' },
      noData: '没有可用数据',
      headerFilters: { default: '筛选列...', columns: {} },
      groups: { item: '项', items: '项' },
      columns: {},
    },
  }) 

  const currentLocale = $i18n?.locale || 'en' // fallback if undefined

  Tabulator.defaultOptions.locale = currentLocale.value;

  // Expose registry and helper to components
  nuxtApp.provide('registerTabulatorTable', registerTable)
})

